"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sum = void 0;
var sum = function sum(columnId, _leafRows, childRows) {
  var allUndefined = true;
  var result = childRows.reduce(function (sum, next) {
    var nextValue = next.getValue(columnId);
    var isNumber = typeof nextValue === 'number';
    if (isNumber) {
      allUndefined = false;
    }
    return sum + (isNumber ? nextValue : 0);
  }, 0);
  return allUndefined ? undefined : result;
};
exports.sum = sum;